<template>
    <div class="globalHeader">

        <!-- 顶部 -->
        <div class="header">
            <div class="container header-inner">

                <div class="logo-wrap">
                    <!-- <img class="logo" src="@/assets/images/home/logo1.png" alt="" /> -->
                    <div class="site-logo">

                        <!-- logo图 -->
                        <img class="logo-img" src="@/assets/images/home/logo.png" alt="" />

                        <!-- 文字 -->
                        <div class="logo-text">

                            <div class="cn-title">
                                中国人力资源开发研究会风险管理分会
                            </div>

                            <div class="en-title">
                                Risk management association of china
                            </div>

                        </div>

                    </div>
                </div>
                <div class="menu-btn" @click="showMobileMenu = true">
                    <i class="el-icon-s-operation" v-if="!showMobileMenu"></i>
                    <i class="el-icon-close" v-else></i>
                </div>
                <!-- <div class="right-box">

                    <div class="search-box">
                        <input placeholder="请输入关键字搜索" />
                        <i class="el-icon-search"></i>
                    </div>

                    <div class="lang-btn">
                        中文 / En
                    </div>

                </div> -->

            </div>
        </div>

        <!-- 导航 -->
        <!-- nav -->
        <div class="nav">

            <!-- PC导航 -->
            <div class="container nav-inner" v-if="!isMobile">

                <div class="nav-item active" @click="redirectPage('/', '')">
                    首页
                </div>

                <!-- 关于分会 -->
                <div class="nav-item dropdown">

                    <div class="nav-title">
                        关于分会
                        <i class="el-icon-caret-bottom"></i>
                    </div>

                    <div class="dropdown-menu">

                        <div class="dropdown-item" @click="redirectPage('/news/branchIntroduction', 1)">
                            分会简介
                        </div>

                        <div class="dropdown-item" @click="redirectPage('/news/historicalMaterials', 2)">
                            历史资料
                        </div>

                        <div class="dropdown-item" @click="redirectPage('/news/boardmember', 3)">
                            分会负责人
                        </div>

                        <div class="dropdown-item" @click="redirectPage('/news/membershipInstructions', 4)">
                            入会说明
                        </div>

                    </div>

                </div>

                <!-- 人才培训 -->
                <div class="nav-item dropdown">

                    <div class="nav-title">
                        人才培训
                        <i class="el-icon-caret-bottom"></i>
                    </div>

                    <div class="dropdown-menu">
                        <div class="dropdown-item" @click="redirectPage('/talent-training/riskManager')">
                            风险管理师
                        </div>

                        <div class="dropdown-item" @click="redirectPage('/talent-training/riskAssessor')">
                            公共风险管理师
                        </div>

                        <div class="dropdown-item" @click="redirectPage('/talent-training/publicRiskManager')">
                            风险评估师
                        </div>

                    </div>

                </div>
                <!-- 人才培训 -->
                <div class="nav-item dropdown">

                    <div class="nav-title">
                        政策法规
                        <i class="el-icon-caret-bottom"></i>
                    </div>

                    <div class="dropdown-menu">

                        <div class="dropdown-item" @click="redirectPage('/policies-regulations/policy-document')">
                            政策文件
                        </div>

                        <div class="dropdown-item" @click="redirectPage('/policies-regulations/laws-regulations')">
                            法律法规
                        </div>

                    </div>

                </div>

                <div class="nav-item" @click="redirectPage('/certificateInquiry')">
                    证书查询
                </div>

            </div>


            <!-- 遮罩 -->
            <div class="mobile-mask" v-if="showMobileMenu" @click="showMobileMenu = false"></div>

            <!-- 侧边菜单 -->
            <div class="mobile-drawer" :class="{ show: showMobileMenu }">

                <!-- 顶部 -->
                <!-- <div class="drawer-top">

                    <div class="drawer-title">
                        导航菜单
                    </div>

                    <i class="el-icon-close" @click="showMobileMenu = false"></i>

                </div> -->

                <!-- H5导航 -->
                <div class="mobile-nav">

                    <!-- 首页 -->
                    <div class="mobile-item active" @click="redirectPage('/', '')">
                        首页
                    </div>

                    <!-- 关于分会 -->
                    <div class="mobile-item">

                        <div class="mobile-title" @click="toggleMenu('about')">
                            <span>关于分会</span>

                            <i class="el-icon-caret-bottom" :class="{ rotate: openMenu === 'about' }"></i>
                        </div>

                        <div class="mobile-dropdown" v-show="openMenu === 'about'">
                            <div class="mobile-dropdown-item" @click="redirectPage('/news/branchIntroduction', 1)">
                                分会简介
                            </div>

                            <div class="mobile-dropdown-item" @click="redirectPage('/news/historicalMaterials', 2)">
                                历史资料
                            </div>

                            <div class="mobile-dropdown-item" @click="redirectPage('/news/boardmember', 3)">
                                分会负责人
                            </div>

                            <div class="mobile-dropdown-item" @click="redirectPage('/news/membershipInstructions', 4)">
                                入会说明
                            </div>
                        </div>

                    </div>

                    <!-- 人才培训 -->
                    <div class="mobile-item">

                        <div class="mobile-title" @click="toggleMenu('news')">
                            <span>人才培训</span>

                            <i class="el-icon-caret-bottom" :class="{ rotate: openMenu === 'news' }"></i>
                        </div>

                        <div class="mobile-dropdown" v-show="openMenu === 'news'">
                            <div class="mobile-dropdown-item" @click="redirectPage('/talent-training/riskManager')">
                                风险管理师
                            </div>

                            <div class="mobile-dropdown-item" @click="redirectPage('/talent-training/riskAssessor')">
                                公共风险管理师
                            </div>

                            <div class="mobile-dropdown-item"
                                @click="redirectPage('/talent-training/publicRiskManager')">
                                风险评估师
                            </div>


                        </div>

                    </div>

                    <!-- 人才培训 -->
                    <div class="mobile-item">

                        <div class="mobile-title" @click="toggleMenu('newss')">
                            <span>政策法规</span>

                            <i class="el-icon-caret-bottom" :class="{ rotate: openMenu === 'newss' }"></i>
                        </div>

                        <div class="mobile-dropdown" v-show="openMenu === 'newss'">
                            <div class="mobile-dropdown-item"
                                @click="redirectPage('/policies-regulations/policy-document')">
                                政策文件
                            </div>

                            <div class="mobile-dropdown-item"
                                @click="redirectPage('/policies-regulations/laws-regulations')">
                                法律法规
                            </div>

                        </div>

                    </div>


                    <div class="mobile-item" @click="redirectPage('/certificateInquiry')">
                        证书查询
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'GlobalHeader',

    data() {
        return {
            openMenu: '',
            isMobile: false,
            showMobileMenu: false
        }
    },
    mounted() {
        this.checkMobile()
        window.addEventListener('resize', this.checkMobile)
    },
    beforeDestroy() {
        clearInterval(this.bannerTimer)
        window.removeEventListener('resize', this.checkMobile)
    },
    methods: {
        // 跳转页面
        redirectPage(url) {
            this.showMobileMenu = false
            this.$router.push(url)
        },
        // 判断H5
        checkMobile() {

            this.isMobile = window.innerWidth <= 768
        },

        // 展开菜单
        toggleMenu(name) {

            if (this.openMenu === name) {

                this.openMenu = ''

            } else {

                this.openMenu = name
            }
        },
    }

}
</script>

<style scoped lang="scss">
/* 遮罩 */
.mobile-mask {
    position: fixed;
    left: 0;
    top: 0;

    width: 100%;
    height: 100vh;

    // background: rgba(0, 0, 0, .45);

    z-index: 1998;
}

/* 抽屉 */
.mobile-drawer {
    position: fixed;

    left: 0;
    top: 60px;

    width: 100%;
    height: calc(100vh - 60px);

    background: #fff;

    z-index: 1999;

    transform: translateX(-100%);

    transition: all .3s;

    overflow-y: auto;
}

.mobile-drawer.show {
    transform: translateX(0);
}

.mobile-item {
    padding-left: 10px;
    border-bottom: 1px solid #eee;
    font-size: 16px;
    color: #333;
    line-height: 44px;
}

/* 顶部 */
.drawer-top {
    height: 56px;

    padding: 0 15px;

    border-bottom: 1px solid #eee;

    display: flex;
    align-items: center;
    justify-content: space-between;
}

.drawer-title {
    font-size: 16px;
    font-weight: 600;
}

.drawer-top i {
    font-size: 22px;
}

/* 一级菜单 */
.drawer-item {
    border-bottom: 1px solid #f2f2f2;
}

.drawer-item.active {
    color: #4b6fd8;
}

/* 菜单标题 */
.drawer-title-row {
    height: 52px;

    padding: 0 15px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    font-size: 15px;
}

.drawer-title-row i {
    transition: all .3s;
}

.drawer-title-row i.rotate {
    transform: rotate(180deg);
}

/* 二级菜单 */
.drawer-dropdown {
    background: #f8f9fb;
}

.drawer-dropdown-item {
    height: 46px;

    padding: 0 30px;

    display: flex;
    align-items: center;

    color: #666;

    border-top: 1px solid #eee;
}

.globalHeader {
    // position: sticky;
    // top: 0;
    // z-index: 999;
    // position: fixed;
    // top: 0;
    // left: 0;
    width: 100%;
}

.logo-wrap {
    display: flex;
}

.site-logo {
    display: flex;
    align-items: center;
    margin-left: 10px;
}

.logo-img {
    width: 72px;
    height: 72px;

    object-fit: contain;
}

.logo-text {
    margin-left: 18px;
}

.cn-title {
    font-size: 28px;
    color: #333;

    font-weight: 500;

    line-height: 1.2;
}

.en-title {
    text-align: center;
    margin-top: 6px;

    font-size: 22px;

    color: #555;
}

/* header */
.header {
    background: #fff;
    height: 100px;
}

.container {
    width: 1200px;
    max-width: calc(100% - 30px);
    margin: 0 auto;
}

.header-inner {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.logo {
    // height: 58px;
}

.right-box {
    display: flex;
    align-items: center;
}

.search-box {
    width: 300px;
    height: 40px;
    border: 1px solid #ddd;
    display: flex;
    align-items: center;
    padding: 0 14px;
    background: #fff;

    input {
        flex: 1;
        border: none;
        outline: none;
    }

    i {
        color: #3f67d8;
        font-size: 18px;
    }
}

.lang-btn {
    width: 110px;
    height: 40px;
    background: #3f67d8;
    color: #fff;
    margin-left: 20px;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
}

/* nav */
.nav {
    background: #CC0000;
    position: relative;
    z-index: 100;
}

.nav-inner {
    display: flex;
}

.nav-item {
    width: 200px;
    height: 60px;
    font-size: 16px;
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;
    cursor: pointer;

    transition: all .3s;

    &:hover {
        background: #CC0000;
        color: #fff;
    }

    &.active {
        background: #CC0000;
        color: #fff;
    }
}

.nav-title {
    display: flex;
    align-items: center;

    i {
        margin-left: 6px;
        font-size: 12px;
    }
}

/* dropdown */
.dropdown-menu {
    position: absolute;
    top: 60px;
    left: 0;

    width: 100%;

    background: #CC0000;

    box-shadow:
        0 4px 12px rgba(0, 0, 0, .08);

    opacity: 0;
    visibility: hidden;

    transform: translateY(10px);

    transition: all .25s;

    z-index: 99;
}

.dropdown:hover {

    .dropdown-menu {
        opacity: 1;
        visibility: visible;
        transform: translateY(0);
    }
}

.dropdown-item {
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;

    transition: all .25s;
}

.menu-btn {
    display: none;
    i {
        font-size: 20px;
    }
}

@media screen and (max-width: 768px) {
    .menu-btn {
        display: block;
    }

    .header {
        height: 60px;
    }

    .menu-btn {
        display: block;
    }

    .logo-wrap {
        width: 100%;
        height: 40px;
        align-items: center;
    }

    .logo {
        width: 100px;
    }

    .site-logo {
        width: 320px;

        .cn-title {
            font-size: 12px;
        }
    }

    .logo-img {
        width: 42px;
        height: 42px;
    }

    .logo-text {
        margin-left: 10px;
    }

    .cn-title {
        font-size: 18px;
    }

    .en-title {
        font-size: 11px;
        line-height: 1.4;
        margin-top: 0;
    }
}
</style>